import { render, staticRenderFns } from "./_betListCS.vue?vue&type=template&id=3d938649&lang=pug&"
import script from "./_betListCS.vue?vue&type=script&lang=js&"
export * from "./_betListCS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports